import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import React from "react";
import { ActivateBtn } from "./components/ActivateBtn";
import { AnullDocument } from "./components/AnullDocument";
import { AbandonDocument } from "./components/AbandonDocument";
import { DocumentHelperActions } from "./components/DocumentHelperActions";
import { ModalUpdateArchive } from "./components/ModalUpdateArchive";
import { ModalUpdateDocument } from "./components/ModalUpdateDocument";
import { ParamsWatcher } from "./components/ParamsWatcher";
import { SectionDescriptionDetail } from "./components/SectionDescriptionDetail";
import { SegmentsSection } from "./components/SegmentsSection";
import { useParams } from "react-router-dom";

import { SetDocumentPending } from "./components/SetDocumentPending";

export const DocumentDetail: React.FC = () => {
  console.log("DocumentDetail Render");

  const { from }: { from: string } = useParams();
  const {userId} : {userId: string} =useParams();

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Acuerdos" : ""}
              defaultHref={from === "detalle"? `/app/supervision/colaborador/subir-firma-digital/${userId}` : `/app/rrhh/acuerdos`}
              color="light"
            />
          </IonButtons>
          <IonTitle>Acuerdo</IonTitle>
          <IonButtons slot="end">
            <DocumentHelperActions />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <section className={isPlatform("desktop") ? "ion-padding" : ""}>
          <ParamsWatcher />
          <SectionDescriptionDetail />
          <SegmentsSection />
          <ModalUpdateDocument />
          <ModalUpdateArchive />
          <AnullDocument />
          <AbandonDocument />
          <SetDocumentPending />
        </section>
      </IonContent>
      <ActivateBtn />
    </IonPage>
  );
};
